/**
 * Convercus ↔ Braze
 * Webhook endpoints exposed to Braze, forwarding to Convercus REST API
 *
 * The version of the OpenAPI document: 1.0.34910
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateBookingDto { 
    /**
     * Booking type
     */
    booking_type: CreateBookingDto.BookingTypeEnum;
    /**
     * Booking type code configured in the program
     */
    booking_type_code: string;
    /**
     * Amount of points to book (positive)
     */
    points: number;
    /**
     * Human-readable reason for the booking
     */
    reason: string;
    /**
     * External reference ID for the booking
     */
    reference_id?: string;
    /**
     * Braze campaign ID for tracking
     */
    braze_campaign_id?: string;
}
export namespace CreateBookingDto {
    export type BookingTypeEnum = 'EARNBOOKING' | 'BURNBOOKING';
    export const BookingTypeEnum = {
        Earnbooking: 'EARNBOOKING' as BookingTypeEnum,
        Burnbooking: 'BURNBOOKING' as BookingTypeEnum
    };
}


